import { NgModule } from '@angular/core';
import { WizLabel } from './wiz-label';
import { CommonModule } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { WizBehaviorDirectiveModule } from '../../../directives/behavior/wiz-behavior-directives.module';

@NgModule({
  declarations: [WizLabel],
  imports: [
    CommonModule,
    MatTooltipModule,
    WizBehaviorDirectiveModule
  ],
  exports: [WizLabel]
})
export class WizLabelModule { }
